<template>
    <div class="automation-integration-tool-body">
        <div class="automation-integration-tool-top">
            <DsSelectField
                v-model="action"
                bind-value-only
                label="Install or Uninstall Automation Integration"
                class="automation-integration-tool-select"
                :options="options"
            />
            <DsFilledButton
                data-qa="dev-tool-install-button"
                class="automation-integration-tool-save-button"
                @click="installIntegration"
            >
                Submit
            </DsFilledButton>
        </div>

        <DsTextAreaField
            v-model="body"
            name="request-body"
            label="Install request body"
            :maxlength="10000"
            class="automation-integration-tool-textarea"
        />
        <div>
            <span v-if="response"><b>Response:</b></span>
            {{ response }}
        </div>
    </div>
</template>

<script>import {
    createTrigger,
    installIntegration,
    uninstallIntegration,
} from '@/components/devtools/funnel.integration.api';

export default {
    data() {
        return {
            body: '',
            action: 'install',
            options: [{
                label: 'Install Automation Integration',
                value: 'install',
            }, {
                label: 'Un-install Automation Integration',
                value: 'uninstall',
            }, {
                label: 'Create Trigger Event',
                value: 'trigger',
            }],
            response: '',
        };
    },

    methods: {
        async installIntegration() {
            if (this.action === 'trigger') {
                try {
                    this.response = await createTrigger(this.body);
                } catch (e) {
                    this.response = e.message;
                }

                return;
            }

            try {
                this.response = this.action === 'install' ? await installIntegration(this.body) : await uninstallIntegration(this.body);
            } catch (e) {
                this.response = e.message;
            }
        },
    },
};

</script>

<style lang="scss" scoped>

.automation-integration-tool-top {
    display: flex;
}

.automation-integration-tool-save-button {
    max-height: 40px;
}

.automation-integration-tool-textarea {
    :deep(.status) {
        display: none;
    }
    :deep(textarea) {
        height: 350px;
    }
}

.automation-integration-tool-select {
    :deep(.dropdown) {
        max-width: 350px;
    }
    :deep(input) {
        width: 350px;
    }
    :deep(label) {
        padding-top: 0;
    }
    :deep(.dropdown-menu-item) {
        max-width: 350px;
    }
}

</style>
